require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-mobiledevhq.json") })
        }
      }, "path---blog-mobiledevhq");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-mobiledevhq!./.cache/json/blog-mobiledevhq.json
// module id = 1010
// module chunks = 231608221292675